const HowToPlay = [
    'Each question is worth 100 points.',
    'For each incorrect answer there will be a deduction of 10 points from your score.',
    'A timer will be running while you are playing the game. If you complete all the questions within the specified time you earn bonus points.',
    'A maximum of 5 incorrect attempts are allowed.',
    'Do not refresh the browser tab while playing the games so that your score does not get lost and not recorded.',
    'Funiwin team wishes you a fun experience and hopes you win your favourite prize!'
]

export default HowToPlay;